<template>
  <div
    :class="[isPc?'chat-list-contain-pc beauty-scroll':'chat-list-contain']"
    ref="contain"
    @click="$emit('click')"
    @scroll="orderScroll"
  >
    <ul ref="ul">
      <li
        v-for="(item,index) in list"
        :key="index"
      >
        <div
          v-if="!item.isMine"
          class="pleft"
        >
          <van-image
            width="0.55rem"
            height="0.55rem"
            round
            fit="cover"
            class="chat-avator"
            :loading-icon="'manager-o'"
            :src="item.avatar"
          />
          <div class="chat-info">
            <div class="info-t">{{item.name}}</div>
            <!-- <div class="info-c">{{item.message}}</div> -->
            <div class="info-c" v-html="item.message"></div>
          </div>
        </div>
        <div
          v-else
          class="pright"
        >
          <div class="chat-info">
            <div class="info-t">{{item.name}}</div>
            <!-- <div class="info-c">{{item.message}}</div> -->
            <div class="info-c" v-html="item.message"></div>
          </div>
          <van-image
            width="0.55rem"
            height="0.55rem"
            round
            fit="cover"
            class="chat-avator"
            :loading-icon="'manager-o'"
            :src="item.avatar"
          />
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    list: {
      type: Array,
      default: function () {
        return []
      },
    }
  },
  data() {
    return {
      alwaysBottom: true, // 是否总是滑到最底部
    }
  },
  watch: {
    list: function () {
      if (this.alwaysBottom) {
        this.$nextTick(() => {
          this.$refs.contain.scrollTop = this.$refs.ul.scrollHeight;
        })
      }
    }
  },
  filters: {
    exchangeSymbol: function(val) {
      return val.replace(/&lt;/g,'<').replace(/&gt;/g,'>')
    }
  },
  computed:{
    ...mapState(['isPc'])
  },
  mounted() {
    // 进来就默认最底部（最新发布的）讨论位置
    this.$refs.contain.scrollTop = this.$refs.ul.scrollHeight - this.$refs.contain.clientHeight
  },
  methods: {
    orderScroll(e) {
      let scrollTop = this.$refs.contain.scrollTop
      let clientHeight = this.$refs.contain.clientHeight
      let scrollHeight = this.$refs.ul.scrollHeight
      // contain的滑动高度和当前可见高总和 近似于列表总高，则认为滑到最底部了，自动滚到最底部
      if (scrollTop + clientHeight >= scrollHeight - 15) {
        this.alwaysBottom = true
      } else {
        this.alwaysBottom = false
      }
    }
  },
}
</script>

<style lang="less" scoped>
.chat-list-contain-pc{
  height: 100%;
  background-color: #222328;
  overflow-y: auto;
  div {
    box-sizing: border-box;
  }
  ul {
  }
  .pleft {
    display: flex;
    justify-content: flex-start;
    margin-left: 0.2rem;
    padding: 0.15rem 0;
    .chat-avator {
    }
    .chat-info {
      max-width: 5.18rem;
      margin-left: 0.1rem;
      .info-t {
        font-size: 0.16rem;
        color: #FFF;
        margin-bottom: 0.07rem;
        margin-left: 0.2rem;
      }
      .info-c {
        position: relative;
        color: #FFF;
        font-size: 0.18rem;
        text-align: left;
        padding: 0.08rem 0.18rem;
        margin-left: 0.2rem;
        max-width: calc(100% - 0.1rem);
        background-color: #464646;
        border-radius: 4px;
        word-break: break-all;
        &::before {
          content: "";
          position: absolute;
          width: 0;
          height: 0;
          top: 0.08rem;
          left: -0.18rem;
          border-top: 0.1rem solid transparent;
          border-bottom: 0.1rem solid transparent;
          border-right: 0.25rem solid #464646;
          transform: skewY(35deg);
        }
      }
    }
  }
  .pright {
    display: flex;
    justify-content: flex-end;
    margin-right: 0.17rem;
    padding: 0.15rem 0;
    .chat-avator {
    }
    .chat-info {
      max-width: 5.18rem;
      margin-right: 0.1rem;
      .info-t {
        font-size: 0.17rem;
        color: #FFF;
        margin-bottom: 0.07rem;
        margin-right: 0.2rem;
        text-align: right;
      }
      .info-c {
        position: relative;
        color: #fff;
        font-size: 0.18rem;
        text-align: left;
        padding: 0.08rem 0.18rem;
        margin-right: 0.2rem;
        max-width: calc(100% - 0.1rem);
        background-color: #464646;
        border-radius: 4px;
        word-break: break-all;
        &::before {
          content: "";
          position: absolute;
          width: 0;
          height: 0;
          top: 0.08rem;
          right: -0.18rem;
          border-top: 0.1rem solid transparent;
          border-bottom: 0.1rem solid transparent;
          border-left: 0.2rem solid #464646;
          transform: skewY(-35deg);
        }
      }
    }
  }
}
.chat-list-contain {
  height: 100%;
  background-color: #f4f4f4;
  overflow-y: auto;
  div {
    box-sizing: border-box;
  }
  ul {
  }
  .pleft {
    display: flex;
    justify-content: flex-start;
    margin-left: 0.1rem;
    padding: 0.15rem 0;
    .chat-avator {
    }
    .chat-info {
      max-width: 3.18rem;
      margin-left: 0.1rem;
      .info-t {
        font-size: 0.13rem;
        color: rgba(51, 51, 51, 0.5);
        margin-bottom: 0.07rem;
        margin-left: 0.2rem;
      }
      .info-c {
        position: relative;
        color: #141414;
        font-size: 0.16rem;
        text-align: left;
        padding: 0.08rem 0.18rem;
        margin-left: 0.2rem;
        max-width: calc(100% - 0.1rem);
        background-color: #fff;
        border-radius: 4px;
        word-break: break-all;
        &::before {
          content: "";
          position: absolute;
          width: 0;
          height: 0;
          top: 0.08rem;
          left: -0.18rem;
          border-top: 0.1rem solid transparent;
          border-bottom: 0.1rem solid transparent;
          border-right: 0.25rem solid #fff;
          transform: skewY(35deg);
        }
      }
    }
  }
  .pright {
    display: flex;
    justify-content: flex-end;
    margin-right: 0.17rem;
    padding: 0.15rem 0;
    .chat-avator {
    }
    .chat-info {
      max-width: 3.18rem;
      margin-right: 0.1rem;
      .info-t {
        font-size: 0.13rem;
        color: rgba(51, 51, 51, 0.5);
        margin-bottom: 0.07rem;
        margin-right: 0.2rem;
        text-align: right;
      }
      .info-c {
        position: relative;
        color: #fff;
        font-size: 0.16rem;
        text-align: left;
        padding: 0.08rem 0.18rem;
        margin-right: 0.2rem;
        max-width: calc(100% - 0.1rem);
        background-color: #2284E5;
        border-radius: 4px;
        word-break: break-all;
        &::before {
          content: "";
          position: absolute;
          width: 0;
          height: 0;
          top: 0.08rem;
          right: -0.18rem;
          border-top: 0.1rem solid transparent;
          border-bottom: 0.1rem solid transparent;
          border-left: 0.2rem solid #2284E5;
          transform: skewY(-35deg);
        }
      }
    }
  }
}
</style>